<template>
    <div>
        <div class="object-titlebox">
            <div class="object-titlebox-left" v-t="'message.item_advanced_setting_edit'"></div>
            <div class="object-titlebox-right">
                <button class="transparent-button" type="button" v-on:click="showDialogCheck()">
                    <img src="@/assets/edit.svg" />
                    <span class="normal-command-text" v-t="'message.common_action_edit'"></span>
                </button>
            </div>
        </div>

        <div class="object-inner-table">
            <table width=100%>
                <!--- 設定内容 --->
                <tr class="object-titlebox" style="display: table-row">
                    <td class="object-titlebox-text" style="padding-left: 20px; width:35%;"
                        v-t="'message.item_setting_value'"></td>
                    <td class="object-titlebox-right" v-t="'message.title_client_enabling'" colspan="2"></td>
                </tr>

                <tr class="setting-item-record">
                    <td class="setting-input-header" v-t="'message.item_advanced_enable_longTalkgroup'"></td>
                    <td v-if="this.enableLongTalkgroup" class="object-right-value" v-t="'message.item_valid'" colspan="2">
                    </td>
                    <td v-else class="object-right-value" v-t="'message.item_invalid'" colspan="2"></td>
                </tr>
            </table>

        </div>
        <editAdvancedSetting v-if="showEditAdvancedSetting" @cancel="showEditAdvancedSetting = false"
            @save="setEnableLongTalkgroup" :enableLongTalkgroup="enableLongTalkgroup" />
    </div>
</template>

<script>
import server from "../../../ServerApi.js";
import commonUtil from '../../../commonutil.js';
import constants from '../../../constants.js';
import EditAdvancedSetting from './EditAdvancedSetting.vue';


export default {
    components: {
        editAdvancedSetting: EditAdvancedSetting
    },

    data() {
        return {
            showEditAdvancedSetting: false,
            enableLongTalkgroup: this.appData.enableLongTalkgroup
        }
    },

    created: function () {

    },

    methods: {
        showDialogCheck() {
            if (!this.appData.tenantAdminUser) {
                commonUtil.notifyMessage(this,"Warning",commonUtil.getMessageText(this.$i18n,"error_cannot_operate_no_tenantAdmin_privilege"));
                return;
            }
            this.showEditAdvancedSetting = true;
        },
        setEnableLongTalkgroup(enableLongTalkgroup) {
            this.showEditAdvancedSetting = false;
            server.post('/setenablelongtalkgroup', {enableLongTalkgroup})
                .then((res) => {
                    switch (res.data.status) {
                        case constants.STATUS_SUCCESS:
                            commonUtil.notifyMessage(this, 'Success', commonUtil.getMessageText(this.$i18n, "item_advanced_setting_added"));
                            this.appData.enableLongTalkgroup = enableLongTalkgroup;
                            this.enableLongTalkgroup = enableLongTalkgroup;
                            break;
                        default:
                            commonUtil.notifyMessage(this, "Error", commonUtil.getMessageText(this.$i18n, "error_server_api").replace("{functionName}", "setenablelongtalkgroup").replace("{code}", res.data.status));
                            break;
                    }
                })
                .catch((error) => {
                    commonUtil.putExceptionErrorMessage(this, "setenablelongtalkgroup", error);
                })
        }
    },
    props: [ 'appData' ]
}
</script>

<style scoped>
.setting-item-record {
    border-bottom: 1px solid #eee;
    text-align: left;
}

.object-right-value {
    width: 65%;
    text-align: right;
    padding-right: 30px;
    color: #848991;
}

.object-value {
    width: 65%;
    color: #848991;
    text-align: left;
    padding-right: 80px;
    overflow-wrap: anywhere;
}

.setting-input-header {
    width: 35%;
    padding-top: 10px;
    padding-bottom: 10px;
    padding-left: 20px;
    padding-right: 20px;
    font-size: 14px;
    text-align: left;
    vertical-align: middle;
}
</style>

